import React, { useState } from 'react';
import { styled } from '../../../../shared/Theme/theme';
import { businessPartner } from '../../../../../models/entities/businessPartner/businessPartner';
import Documents from './Documents/DocumentsTab';
import Contacts from './Contacts/ContactsTab';
import ProductsTab from './Products/ProductsTab';
import Addresses from './Addresses/AddressesTab';
import InventoryTab from './Inventory/InventoryTab';
import AccountingTab from './Accounting/AccountingTab';
import FinancialDocumentsTab from './Accounting/FinancialDocumentsTab';
import ActivityLogTab from './ActivityLogTab';
import Overview from './Overview';
import TabsContainer from '../../../../shared/Tabs/TabsContainer';
import Tab from '../../../../shared/Tabs/Tab';
import { settings } from '../../../../../models/entities/businessPartner/businessPartner';
import { product } from '../../../../../models/entities/product/product';
import { drawers } from '../../../../../state/ducks/header/header';
import { userInfo } from '../../../../../models/entities/user';
import { RcFile } from 'antd/lib/upload';

type Props = {
    businessPartner: businessPartner;
    products: product[];
    localization?: any;
    settings?: settings;
    setDrawerOpen: (open: drawers, params?: any) => void;
    users?: userInfo[];
    updateBusinessPartnerLogo?: (businessPartnerId: string, file: RcFile) => Promise<void>;
    showLogoLoader?: boolean;
};

const CompanyTabs = ({
    businessPartner,
    products,
    localization,
    settings,
    setDrawerOpen,
    users,
    updateBusinessPartnerLogo,
    showLogoLoader
}: Props) => {
    const isCargoOwner = businessPartner.type === 'CARGO_OWNER';
    const [activeTab, setActiveTab] = useState(
        isCargoOwner
            ? 'General'
            : !!products?.length
            ? 'Products'
            : businessPartner.type === 'WAREHOUSE'
            ? 'Inventory'
            : 'Contacts'
    );
    return (
        <TabsContainer>
            {isCargoOwner && (
                <Tab title="General" onClick={() => setActiveTab('General')} isActive={activeTab === 'General'}>
                    <TabPane>
                        <Overview
                            businessPartner={businessPartner}
                            localization={localization}
                            settings={settings}
                            users={users ?? []}
                            updateBusinessPartnerLogo={updateBusinessPartnerLogo ?? (async () => {})}
                            showLogoLoader={!!showLogoLoader}
                            hideFieldsShownInCompactHeader
                        />
                    </TabPane>
                </Tab>
            )}
            {!!products?.length && (
                <Tab title="Products" onClick={() => setActiveTab('Products')} isActive={activeTab === 'Products'}>
                    <TabPane>
                        <ProductsTab products={products} localization={localization.products} setDrawerOpen={setDrawerOpen} />
                    </TabPane>
                </Tab>
            )}
            {businessPartner.type === 'WAREHOUSE' && businessPartner.inventory && (
                <Tab title="Inventory" onClick={() => setActiveTab('Inventory')} isActive={activeTab === 'Inventory'}>
                    <TabPane>
                        <InventoryTab inventory={businessPartner.inventory} />
                    </TabPane>
                </Tab>
            )}
            <Tab title="Contacts" onClick={() => setActiveTab('Contacts')} isActive={activeTab === 'Contacts'}>
                <TabPane>
                    <Contacts contacts={businessPartner.contacts} localization={localization} />
                </TabPane>
            </Tab>
            <Tab title="Documents" onClick={() => setActiveTab('Documents')} isActive={activeTab === 'Documents'}>
                <TabPane>
                    <Documents documents={businessPartner.documents?.documents} localization={localization} settings={settings} />
                </TabPane>
            </Tab>
            <Tab title="Addresses" onClick={() => setActiveTab('Addresses')} isActive={activeTab === 'Addresses'}>
                <TabPane>
                    <Addresses addresses={businessPartner.addresses} localization={localization} />
                </TabPane>
            </Tab>
            {isCargoOwner && (
                <Tab title="Accounting" onClick={() => setActiveTab('Accounting')} isActive={activeTab === 'Accounting'}>
                    <TabPane $flush>
                        <AccountingTab businessPartner={businessPartner} settings={settings} />
                    </TabPane>
                </Tab>
            )}
            {isCargoOwner && (
                <Tab
                    title="Financial Documents"
                    onClick={() => setActiveTab('Financial Documents')}
                    isActive={activeTab === 'Financial Documents'}
                >
                    <TabPane $flush>
                        <FinancialDocumentsTab businessPartner={businessPartner} settings={settings} />
                    </TabPane>
                </Tab>
            )}
            {isCargoOwner && (
                <Tab title="Activity Log" onClick={() => setActiveTab('Activity Log')} isActive={activeTab === 'Activity Log'}>
                    <TabPane>
                        <ActivityLogTab
                            businessPartnerId={businessPartner.id}
                            isActive={activeTab === 'Activity Log'}
                            users={users ?? []}
                        />
                    </TabPane>
                </Tab>
            )}
        </TabsContainer>
    );
};

const TabPane = styled.div<{ $flush?: boolean }>`
    padding: ${(p) => (p.$flush ? '16px 4px 4px' : '18px 8px 8px')};
`;

export default CompanyTabs;
